import {ISupplierUserProfile, IUser} from 'constants/interfaces';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Grid, Paper, Typography} from '@material-ui/core';
import React, {useCallback, useEffect, useState} from 'react';
import {Route} from 'react-router-dom';
import {Breakpoint} from '@material-ui/core/styles/createBreakpoints';
import {apiGetUser} from 'constants/Api';
import {CustomerFinancials} from './CustomerFinancials';
import {ProgramCreate} from 'screens/Dashboard/Programs/ProgramCreate/ProgramCreate';
import {CreateProgramState} from 'appredux/reducers/reducer-create-program';
import {ProductState} from 'appredux/reducers/reducer-products';
import {CustomerDetail} from './CustomerDetail';
// eslint-disable-next-line max-len
import CustomerDashboardMapping from 'screens/Dashboard/Customers/CustomerDetail/CustomerDashboardMapping/CustomerDashboardMapping';

enum ECustomerTab {
  Snapshot = 'snapshot',
  CustomerProfile = 'customer-profile',
  FarmProfile = 'farm-profile',
  FinancialInfo = 'financial-info',
  Chat = 'chat',
  Programs = 'programs',
}

export function CustomerLanding(props: {
  user: ISupplierUserProfile;
  customerUserId: string;
  width: Breakpoint;
  productState: ProductState;
  createProgramState: CreateProgramState;
}) {
  const {customerUserId} = props;
  const [activeTab, setActiveTab] = useState(ECustomerTab.Snapshot);

  const [tabIndex] = useState(0);
  const showTabs = props.width === 'xs' || props.width === 'sm';

  const [loadingCustomer, setIsLoadingCustomer] = useState<boolean>(false);
  const [customer, setCustomer] = useState<IUser>();

  const customerFullName = customer?.farmer
    ? customer.farmer.name + ' ' + customer.farmer.surname
    : customer
    ? customer.name + ' ' + customer.surname
    : '';

  const loadCustomer = useCallback((customerUserId: string) => {
    setIsLoadingCustomer(true);
    apiGetUser(customerUserId)
      .then(setCustomer)
      .catch((error) => {
        alert('Error loading customer. Please try again later');
        console.error(error);
      })
      .then(() => setIsLoadingCustomer(false));
  }, []);

  useEffect(() => {
    loadCustomer(customerUserId);
  }, [customerUserId, loadCustomer]);

  const tabsDisplay = [
    {name: 'Snapshot', key: ECustomerTab.Snapshot},
    {name: 'Customer Profile', key: ECustomerTab.CustomerProfile},
    {name: 'Farm Profile', key: ECustomerTab.FarmProfile},
    {name: 'Financial Information', key: ECustomerTab.FinancialInfo},
    {name: 'Chat', key: ECustomerTab.Chat},
    {name: 'Programs', key: ECustomerTab.Programs},
  ];
  console.log(loadingCustomer);
  return (
    <div className="order-detail">
      <AppBar className="app-bar" elevation={0}>
        <Toolbar>
          <Route
            render={({history}) => (
              <IconButton
                edge="start"
                color="inherit"
                onClick={() =>
                  history.location.key
                    ? history.goBack()
                    : history.replace('/customers')
                }
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            )}
          />
          <Typography variant="h6" className="title">
            {customerFullName}
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid container className="container">
        <Paper className="order-info-container" variant="outlined">
          <Grid
            item
            xs={12}
            md={12}
            className="grid-column"
            style={{display: showTabs && tabIndex === 0 ? 'none' : ''}}
          >
            <div className="p-4">
              {/* Tabs */}
              <div className="flex border-b">
                {tabsDisplay.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`px-4 py-2 text-gray-700 ${
                      activeTab === tab.key
                        ? 'border-b-2 border-green-500 font-semibold'
                        : ''
                    }`}
                  >
                    {tab.name}
                  </button>
                ))}
              </div>
            </div>
            <div className="mt-4 p-4 border rounded-lg">
              {activeTab === ECustomerTab.FinancialInfo && (
                <CustomerFinancials {...props} />
              )}
              {activeTab === ECustomerTab.Programs && (
                <ProgramCreate {...props} />
              )}
              {activeTab === ECustomerTab.Chat && <CustomerDetail {...props} />}
              {activeTab === ECustomerTab.FarmProfile && (
                <Route
                  path="/customers/:customerUserId"
                  component={CustomerDashboardMapping}
                />
              )}
            </div>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
}
